import React, { useEffect, useRef } from 'react';
import * as d3 from 'd3';

const RunBoostChart = ({ data }) => {
    const svgRef1 = useRef(null);
    const svgRef2 = useRef(null);

    useEffect(() => {
        if (!data || data.length === 0) return;

        const margin = { top: 20, right: 20, bottom: 30, left: 50 };
        const width = 250 - margin.left - margin.right;
        const height = 200 - margin.top - margin.bottom;

        // --- Chart 1: Run Boost ---
        const svg1 = d3.select(svgRef1.current);
        svg1.selectAll('*').remove();

        const x1 = d3.scaleBand()
            .range([0, width])
            .domain(data.map(d => d.name))
            .padding(0.1);

        const y1 = d3.scaleLinear()
            .range([height, 0])
            .domain([0, d3.max(data, d => d.funtorun)]);

        const g1 = svg1.append('g')
            .attr('transform', `translate(${margin.left}, ${margin.top})`);

        g1.call(d3.axisLeft(y1));

        g1.selectAll('.lollipop-line')
            .data(data)
            .enter()
            .append('line')
            .attr('x1', d => x1(d.name) + x1.bandwidth() / 2)
            .attr('x2', d => x1(d.name) + x1.bandwidth() / 2)
            .attr('y1', d => y1(d.funtorun))
            .attr('y2', y1(0))
            .attr('stroke', 'steelblue')
            .attr('stroke-width', 1);

        g1.selectAll('.lollipop-circle')
            .data(data)
            .enter()
            .append('circle')
            .attr('cx', d => x1(d.name) + x1.bandwidth() / 2)
            .attr('cy', d => y1(d.funtorun))
            .attr('r', 5)
            .attr('fill', 'steelblue');

        svg1.append("text")
            .attr("x", (width / 2) + margin.left)
            .attr("y", margin.top / 2 + 5)
            .attr("text-anchor", "middle")
            .style("font-size", "12px")
            .style("fill", "steelblue")
            .text("Run Boost");


        // --- Chart 2: BPM ---
        const svg2 = d3.select(svgRef2.current);
        svg2.selectAll('*').remove();

        const x2 = d3.scaleBand()
            .range([0, width])
            .domain(data.map(d => d.name))
            .padding(0.1);

        const y2 = d3.scaleLinear()
            .range([height, 0])
            .domain([0, 220]);

        const g2 = svg2.append('g')
            .attr('transform', `translate(${margin.left}, ${margin.top})`);

        g2.call(d3.axisLeft(y2));

        g2.selectAll('.lollipop-line')
            .data(data)
            .enter()
            .append('line')
            .attr('x1', d => x2(d.name) + x2.bandwidth() / 2)
            .attr('x2', d => x2(d.name) + x2.bandwidth() / 2)
            .attr('y1', d => y2(d.tempo))
            .attr('y2', y2(0))
            .attr('stroke', 'red')
            .attr('stroke-width', 1);

        g2.selectAll('.lollipop-circle')
            .data(data)
            .enter()
            .append('circle')
            .attr('cx', d => x2(d.name) + x2.bandwidth() / 2)
            .attr('cy', d => y2(d.tempo))
            .attr('r', 5)
            .attr('fill', 'red');

        svg2.append("text")
            .attr("x", (width / 2) + margin.left)
            .attr("y", margin.top / 2 + 5)
            .attr("text-anchor", "middle")
            .style("font-size", "12px")
            .style("fill", "red")
            .text("BPM");

    }, [data]);

    return (
        <div className="d-flex justify-content-center flex-wrap">
            <div style={{ marginRight: '10px' }}>
                <svg ref={svgRef1} width={250} height={200} />
            </div>
            <div>
                <svg ref={svgRef2} width={250} height={200} />
            </div>
        </div>
    );
};

export default RunBoostChart;
